import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../../utils";
import PageSubheader from "../../../../../components/PageSubheader";
import QuoteRequestServiceForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateQuoteRequestService = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.quote.request.service.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-quote-request-service-create"
        goBackURL={backURL}
      />

      <QuoteRequestServiceForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateQuoteRequestService));
